<div class="container">

  <div class="row">

    <div class="col-12 col-lg-10 offset-lg-1">

      <h2>
        <span>{{ 'Ihr Arbeitsort' | localize }}</span>
      </h2>
    
    </div>

  </div>

</div>

<app-tabnav #tabnav></app-tabnav>

<div class="container">

  <div class="row">


    <div class="col-12 col-lg-10 offset-lg-1">


      <div id="joblocation" class="row">


          <div class="col-12 col-md-4 col-lg-3 mb-4 mb-md-0">         
            <p innerHTML="{{jobLocation}}"></p>         
          </div>          

          <div class="col-auto" *ngIf="hasRoute">  

              <div class="row">

                  <div class="col-auto d-none d-lg-block">
                    <i class="fa-sharp fa-solid fa-car fa-2x mr--2"></i>
                  </div>

                  <div class="col-auto">          
                      <p>
                        <i class="fa-sharp fa-solid fa-car mr-2 d-lg-none"></i>
                          <strong class="text-success">{{jobTravelTime}}</strong><br>
                          {{jobDistance}}
                      </p>          
                  </div>

              </div>      

          </div>
      </div>
    </div>
  </div>

</div>

<div id="gmap" #gmap></div>